import { companyApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';

export const updateCompanyBrandingAction = catchAsyncActionError(
  ({ companyId, branding }) =>
    async () => {
      const { data } = await companyApi.updateCompanyBranding({ companyId, branding });

      return data;
    },
);

export const uploadCompanyImageAction = catchAsyncActionError(
  ({ companyId, type, formData }) =>
    async () => {
      const { data } = await companyApi.uploadCompanyImage({ companyId, type, formData });

      return data;
    },
);
